import React from 'react';
import styled from 'styled-components';
import IconLocalShipping from '@tvg/fuse-icons/lib/LocalShipping';
import { Icon, TypographyComponent as TypographyElement, Link } from '@tvg/fuse-design';
import { DeliveryCardProps } from '../DeliveryAndReturnsProps';

const Container = styled.div`
  display: flex;
  margin-bottom: var(--spacing-space16);
`;

const IconContainer = styled.div`
  flex: 0 0 32px;
  position: relative;
`;

const TextContainer = styled.div<{ withLink: boolean }>`
  display: flex;
  flex: 1 1 0%;
  align-items: ${(props) => (props.withLink ? 'normal' : 'center')};
  flex-direction: ${(props) => (props.withLink ? 'column' : 'row')};
  margin-left: var(--spacing-space12);

  strong {
    color: var(--color-global-grey1000);
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

function DeliveryCard(props: DeliveryCardProps) {
  const { onClick, link, text } = props;

  return (
    <Container data-testid="delivery-card">
      <IconContainer>
        <Icon icon={<IconLocalShipping />} width="32px" height="32px" dataTestId="delivery-card-icon" />
      </IconContainer>

      <TextContainer withLink={!!link}>
        <TypographyElement
          tag="p"
          type="paragraph"
          size="m1"
          data-testid="delivery-card-text"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />

        {link && (
          <Link
            href="#"
            onClick={(event: MouseEvent) => {
              event.preventDefault();
              onClick();
            }}
            data-testid="delivery-card-link"
            size="medium"
            dangerouslySetInnerHTML={{
              __html: link,
            }}
          />
        )}
      </TextContainer>
    </Container>
  );
}

export default DeliveryCard;
